import { Skeleton } from 'antd';
import { Role } from 'features/auth/types';
import { useReduxAuthStore } from 'lib/hooks/auth/use-auth';
import { Switch } from 'react-router-dom';
import { ClinicianRoutePrefix, PatientRoutePrefix } from 'routes';
import { PrivateRoute } from '../components/routes/private-route';
import {
  ClinicianRouter,
  ClinicianRouteSwitchWrapper
} from './route-switch-clinician/route-switch-clinician';
import { PatientRouteSwitch } from './route-switch-patient';

export function RouteSwitchUser() {
  const auth = useReduxAuthStore();

  if (!auth.user?.uid) {
    return (
      <>
        <h1>Loading authentication data...</h1>
        <Skeleton active />
      </>
    );
  }
  const role = auth.user.role;
  switch (role) {
    case Role.Patient:
      return (
        <Switch key="patient">
          <PrivateRoute
            roles="*"
            path={PatientRoutePrefix}
            component={PatientRouteSwitch}
            redirectPath={'/'}
            passwordCheck
          />
        </Switch>
      );
    default:
      return (
        <div key="clinician">
          <ClinicianRouteSwitchWrapper clinicianId={auth.user.uid}>
            <Switch key="clinician">
              <PrivateRoute
                roles="*"
                path={PatientRoutePrefix}
                component={PatientRouteSwitch}
                redirectPath={'/'}
                passwordCheck
              />
              <PrivateRoute
                roles={[Role.Clinician, Role.ClinicAdmin]}
                path={ClinicianRoutePrefix}
                component={ClinicianRouter}
                redirectPath={'/'}
                passwordCheck
              />
            </Switch>
          </ClinicianRouteSwitchWrapper>
        </div>
      );
  }
}
